<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import UPDATE from '../components/page/update.vue'
  import Url from '@/views/mis/util/url'
  import Qs from 'qs'
  let typeList = {};
  let typeUrlMap = {};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    mounted(){
        this.dataChanage(Url.active.type.queryAll,{},res => {
            if (res.code == 0){
                let arr = res.result;
                for (const i in arr) {
                    typeList[arr[i].type] = arr[i].type;
                    let urlList = (arr[i].url || []).split(",");
                    let urlObj = {};
                    for(const j in urlList){
                        urlObj[urlList[j]] = urlList[j];
                    }
                    typeUrlMap[arr[i].type] = urlObj;
                }
                this.updateData.cols = [
                    { title: 'id', field: 'id',hidden:true},
                    { title: window.$t('mis.activeTemplate.type'), field: 'type',type:2,optionList:typeList,readonly:(model,col)=>{
                        return model.id?true:false;
                        },required:true},
                    { title: window.$t('mis.activeTemplate.title'), field: 'title',required:true},
                    { title: window.$t('mis.activeTemplate.activeTime'), field: 'activeTime',type:9,data:[],required:true},
                    { title: window.$t('mis.activeTemplate.author'), field: 'author',required:true},
                    { title: window.$t('mis.activeTemplate.url'), field: 'url',type:2,optionListObjRender:(model,full)=>{
                        return typeUrlMap[model.type];
                        },required:true},
                    { title: window.$t('mis.activeTemplate.detail'), field: 'detail',hidden:true},
                ];
            }
        })
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
            row.activeTime=[row.startTime,row.endTime];
            this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
            this.dataChanage(Url.active.type.del,{id:row.id},res => {
                this.$refs.childTable.defaultGetData(this.queryData);
                if (res.code == 0){
                    this.$refs.childUpdate.close();
                    this.$message.success("suc");
                }else{
                    this.$message.error(res.message);
                }
            })
        }else if(clickName == "detail"){
            this.$router.push({path:"/mis/activeTemplate/activetemplateDetail",query:{id:row.id,label:"MIS"}});
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('mis.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if(window.$t('mis.bt.add') == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        model.startTime = model.activeTime[0];
        model.endTime = model.activeTime[1];
        this.dataChanage(model.id?Url.active.active.edit:Url.active.active.save,model,res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('mis.activeTemplate.type'), field: 'type'},
              {click: window.$t('mis.bt.search')},
              {click: window.$t('mis.bt.add')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.active.query,
          selection: true,
          sequence: true,
          cols: [
              { title: 'id', field: 'id'},
              { title: window.$t('mis.activeTemplate.type'), field: 'type'},
              { title: window.$t('mis.activeTemplate.title'), field: 'title'},
              { title: window.$t('mis.common.startTime'), field: 'startTime'},
              { title: window.$t('mis.common.endTime'), field: 'endTime'},
              { title: window.$t('mis.activeTemplate.author'), field: 'author'},
              { title: window.$t('mis.activeTemplate.url'), field: 'url'},
              {title:window.$t('mis.bt.operation'),btnClick:[{name:window.$t('mis.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},{name:window.$t('mis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete"},{name:window.$t('mis.activeTemplate.detail'),click:"detail",type:"primary",icon: "el-icon-edit"}]},
          ]
        }
      }
    }
  }
</script>
